import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'crm-toggler-icon-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toggler-icon-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TogglerIconTableComponent {
  @Input() public isShow = false;
  @Input() public fontSize = 1.4;
  @Input() public color: string = null;

  @Output() public isShowChange = new EventEmitter<boolean>();

  public click(event: MouseEvent) {
    event.stopPropagation();
    this.isShow = !this.isShow;
    this.isShowChange.emit(this.isShow);
  }
}
